import { Theme, ThemeProvider } from '@mui/material';
import React from 'react';

export type TooltipParams = {
  value: number;
  seriesName: string;
  xName: string;
  color: string;
  death_count: number;
  injured_count: number;
};

export default function Tooltip({
  theme,
  value,
  color,
  xName,
  seriesName,
  death_count,
  injured_count,
}: {
  theme: Theme;
} & TooltipParams) {
  return (
    <ThemeProvider theme={theme}>
      <div
        className="tooltipContainer"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 8,
          color: theme.palette.text.primary,
          backgroundColor: 'transparent',
          padding: 8,
          borderRadius: 4,
        }}
      >
        <span style={{ fontSize: 8 }}>{xName}</span>
        <span style={{ fontSize: 12 }}>{seriesName}</span>

        <div style={{ display: 'flex', gap: 12 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              padding: '5px 10px 3px 10px',
              paddingLeft: 10,
              borderLeftWidth: 2,
              borderLeftColor: color,
              borderLeftStyle: 'solid',
              borderRadius: 4,
              backgroundColor:
                theme.palette.customBackgrounds.chartTooltipValue,
            }}
          >
            <span style={{ fontSize: 12 }}>Кол-во</span>
            <span style={{ fontSize: 24, fontWeight: 'bold' }}>{value}</span>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontSize: 12 }}>{'Погибло:'}&nbsp;</span>
              <span style={{ fontSize: 12 }}>{death_count}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontSize: 12 }}>{'Ранено:'}&nbsp;</span>
              <span style={{ fontSize: 12 }}>{injured_count}</span>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
